import React, { Component } from 'react';
import classes from './PersonalInfo.css';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import Message from '../../../../components/Message/Message';
import { getTargetUrlDropDownSortedList } from '../../../../shared/utility';
import {ACCOUNT_ADMIN, LOCALE_LIST, AUTO_COMPLETE_SELECT_ENABLE, SESSION_BASELINEAGENT, HSID_BASE, ID_TYPE_NEW} from '../../../../shared/Constants';

class MemberPopUp extends Component {

    state = {
        memberPopUpForm: {
            targetPortal: {
                elementType: AUTO_COMPLETE_SELECT_ENABLE ? 'autocompleteselect' : 'mobileappselect',
                elementConfig: {
                    type: 'text',
                    id: 'targetPortal',
                    placeholder: 'Select One',
                    options: getTargetUrlDropDownSortedList(this.props.portalsList, ACCOUNT_ADMIN, this.props.disabledPortals, this.props.agentUserType),
                    cssProperties: {
                      width: "280%",
                      left: "-90%",
                    }
                },                
                value: '',
                validation: {
                    required: false
                },
                disabled: false,
                disableMobApp: this.props.submitButton === "resetPW" || this.props.submitButton === "resetSQ" || this.props.submitButton === "deletePhone" ? true : false,
                valid: true,
                touched: false,
                label: "Target Portal",
                inputType: "TwoThirdMarginLeft",
            },
            languages: {
                elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'languages',
                    placeholder: 'Select One',
                    options: [
                        { value: 'en', displayValue: 'English (en)' }
                    ]
                },                
                value: 'en',
                validation: {
                    required: false
                },
                disabled: true,
                valid: true,
                touched: false,
                label: "Language",
                inputType: "TwoThirdMarginLeft",
            }
        },
        formIsValid: false,
        message: null,
        popUpMessage: null,
    }

    inputChangedHandler =(event, inputIdentifier) => {
        let updatedForm = {...this.state.memberPopUpForm};
        let targetValue = event.target.value;

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = targetValue
        updatedForm[inputIdentifier] = updatedFormElement;
        let langInfo = [];

        if(inputIdentifier === 'targetPortal'){
            if(targetValue){
                let isPEorSDKPortal = this.props.portalsInfo[targetValue].isSdkPortal || this.props.portalsInfo[targetValue].isPePortal || this.props.portalsInfo[targetValue].isBaseAgentPortal;
                langInfo = !isPEorSDKPortal ? this.props.portalsInfo[targetValue].languages : this.props.portalsInfo[targetValue].uiConfig.locales;
                if(!isPEorSDKPortal && langInfo.length > 1 ){
                    updatedForm['languages'].elementConfig.options = langInfo.map(obj => ({"value": obj.name, "displayValue": LOCALE_LIST[obj.name].label + " ( " + obj.name + " )"}));
                    updatedForm['languages'].disabled = false;
                }else if(isPEorSDKPortal && Object.keys(langInfo).length > 1){
                    updatedForm['languages'].elementConfig.options = Object.keys(langInfo).map(obj => ({"value": obj, "displayValue": LOCALE_LIST[obj].label + " ( " + obj + " )"}));
                    updatedForm['languages'].disabled = false;
                }else{
                    updatedForm['languages'].disabled = true;
                    updatedForm['languages'].value = 'en';
                }             
            }
        }
        this.setState({memberPopUpForm: updatedForm});
    }

    componentDidMount(){
        this.props.setMemPopUpDisplayMessage({type: "Error", info: {message:null}});
    }

    memberPopUpHandler = (event) => {
        event.preventDefault();
        const invalidFields = this.validateForm();
        if(invalidFields === 0){
            let formData = this.props.formData;
            let prtlValue = this.state.memberPopUpForm['targetPortal'].value;
            let prtlData = this.props.portalsList.find( list => list.portalShortName === prtlValue);
            formData.selectLangPortal = this.state.memberPopUpForm['languages'].value;
            formData.targetPortal = prtlData.portalShortName;
            formData.brandName = prtlData.portalBrandName;
            formData.isBaseAgentPortal = prtlData.isBaseAgentPortal;
            if(prtlData.isSdkPortal || prtlData.isBaseAgentPortal){
                formData = {
                    ...formData,
                    sdkPortal : prtlData.isSdkPortal,
                    targetUrl : prtlData.uiConfig.locales.en.targetUrl,
                    hsidDomainUrl: prtlData.uiConfig.hsidDomainUrl,
                    brandUrl: prtlData.uiConfig.brandUrl
                }
            }
            if(this.props.submitButton === "PersInfo"){
                this.props.modifyAccountStart();
                this.props.modifyAccount(formData);
            }else if(this.props.submitButton === "resetPW"){
                this.props.modalSpinnerStart();
                this.props.resetPassword(formData);
            }else if(this.props.submitButton === "resetSQ"){
                this.props.modalSpinnerStart();
                this.props.resetSecurityQues(formData);
            }else if(this.props.submitButton === "verifyPhone"){
                this.props.modifyAccountStart();
                this.props.verifyEmailorPhone(formData);
            }else if(this.props.submitButton === "verifyEmail"){
                this.props.modifyAccountStart();
                this.props.verifyEmailorPhone(formData);
            }else if(this.props.submitButton === "deletePhone"){
                this.props.modalSpinnerStart();
                this.props.deletePhone(formData);
            }else if(this.props.submitButton === "deleteSecondaryEmail"){
                this.props.modalSpinnerStart();
                this.props.deleteSecondaryEmail(formData);
            }
            this.props.closeModal();
        }
    }

    validateForm () {
        let invalidFields =[];
        for( let key in this.state.memberPopUpForm) {
            if(!this.state.memberPopUpForm[key].value) {
                const fieldName = this.state.memberPopUpForm[key].label;
                invalidFields.push(fieldName);
            } 
        }
        const displayText = invalidFields.length>0?invalidFields.length===1?invalidFields.join(" ").concat(" field is required"):invalidFields.join(", ").concat(" fields are required"): null;
        this.props.setMemPopUpDisplayMessage({type: "Error", info: {message:displayText}});
        
        return invalidFields.length;
    }

    render() {

        // console.log("[MemberPopUp] render portalsList", this.props.portalsList);

        const formsElementsArray =[];

        for(let key in this.state.memberPopUpForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.memberPopUpForm[key]
            });
        }   
        
        let buttons = (
            <div style={{ display: "flex", justifyContent: "center"}}>
                <Button id="cancel" btnType="Cancel" clicked={this.props.closeModal}>Cancel</Button>
                <Button id="save" btnType="Search">Save</Button>
            </div>
        );

        let memberPopUpForm = (
            <form onSubmit={this.memberPopUpHandler}>
                <div>
                    {formsElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            disabled={formElement.config.disabled}
                            disableMobApp={formElement.config.disableMobApp}
                            label={formElement.config.label}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            extendedInput={formElement.config.extendedInput}
                            inputType={formElement.config.inputType}
                        />
                    ))}
                </div>
                {buttons}
            </form>
        );

        const errorMessage = this.props.popUpMessage!==null? <div className={classes.RowMessage}><Message msgType={this.props.popUpMessage.type} info={this.props.popUpMessage.info} /></div>: null;
        return (
            <div>
                <div className={classes.FormTitle}>{this.props.formHeader}</div>
                {this.props.children}
                {errorMessage}
                {memberPopUpForm}
            </div>
        );
    }
}

export default MemberPopUp;
